import ajax from '@/utils/ajax.js'
import Cookies from 'js-cookie'
import { Message } from 'element-ui';

export function webInfo(){
    return ajax.get({"action":"WebView"})
   
}

//这是旧的
// export function login({userName="",userPwd=""}){
//     return ajax.post({action:'LoginUser',userName,userPwd})
// }
// export function outLogin(){
//     Cookies.remove('SLCOOKIE')
// }



// export function getUserInfo(){
//     //Cookies.get('SLCOOKIE')
//     let data = ajax.post({action:'SLCOOKIE',yfCookie:Cookies.get('SLCOOKIE')})
//     if(data.code==1){
//         return data.user
//     }else{
//         return false
//     }
// }

export function getPortalToken() {
    return new Promise((resolve, reject) => {

        $.ajax({
            url:(process.env.NODE_ENV==='development'? process.env.API_URL:location.origin)+"/portal/vue/YfPortalOtherServlet",
            data:{action:'getPortalToken' },    //参数值
            type:'post',   //请求方式
            dataType:'text',
            success:function(result){
                try{
                    result = JSON.parse(result)
                    Cookies.set('portalToken',result.token)
                    resolve()
                }catch(err){
                    Cookies.set('portalToken',result)
                    resolve()
                }

               
            },
            error:function(){ 
                Message.error('无法获得portalToekn，无法获得数据')
            }
        });
    })
}


const Base64 = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    encode: function(e) {
     var t = "";
     var n, r, i, s, o, u, a;
     var f = 0;
     e = Base64._utf8_encode(e);
     while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = (n & 3) << 4 | r >> 4;
      u = (r & 15) << 2 | i >> 6;
      a = i & 63;
      if (isNaN(r)) {
       u = a = 64
      } else if (isNaN(i)) {
       a = 64
      }
      t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
     }
     return t
    },
    decode: function(e) {
     var t = "";
     var n, r, i;
     var s, o, u, a;
     var f = 0;
     e=e.replace(/[^A-Za-z0-9+/=]/g,"");
     while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = s << 2 | o >> 4;
      r = (o & 15) << 4 | u >> 2;
      i = (u & 3) << 6 | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
       t = t + String.fromCharCode(r)
      }
      if (a != 64) {
       t = t + String.fromCharCode(i)
      }
     }
     t = Base64._utf8_decode(t);
     return t
    },
    _utf8_encode: function(e) {
     e = e.replace(/rn/g, "n");
     var t = "";
     for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
       t += String.fromCharCode(r)
      } else if (r > 127 && r < 2048) {
       t += String.fromCharCode(r >> 6 | 192);
       t += String.fromCharCode(r & 63 | 128)
      } else {
       t += String.fromCharCode(r >> 12 | 224);
       t += String.fromCharCode(r >> 6 & 63 | 128);
       t += String.fromCharCode(r & 63 | 128)
      }
     }
     return t
    },
    _utf8_decode: function(e) {
     var t = "";
     var n = 0;
     var r =0, c1 =0, c2 = 0;
     while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
       t += String.fromCharCode(r);
       n++
      } else if (r > 191 && r < 224) {
       c2 = e.charCodeAt(n + 1);
       t += String.fromCharCode((r & 31) << 6 | c2 & 63);
       n += 2
      } else {
       c2 = e.charCodeAt(n + 1);
      var c3 = e.charCodeAt(n + 2);
       t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
       n += 3
      }
     }
     return t
    }
   }

import CryptoJS from 'crypto-js'

const sha2 = (str)=> {
    var hash = CryptoJS.SHA256(str);
    return hash.toString(CryptoJS.enc.Hex);
}


//这是新的
export function login({userName="",userPwd="",slideX=""}){
    console.log(userName,userPwd,slideX)
    
    var timestamp = Math.floor(new Date().getTime() / 1000);

    const sign =sha2(userName+","+userPwd+","+timestamp)

    console.log(userName+","+userPwd+","+timestamp)

    return new Promise((resolve, reject)=>{
        $.ajax({
            url: "/school/YfTokenServlet",
            data:{actionServlet:'YfLogin',   timestamp,sign,userName,slideX},    //参数值
            type:'post',   //请求方式
             headers: { 
                "portaltoken": Cookies.get('portalToken') ,
            } ,
            success:function(data){
                console.log(data)
                if(data.code===1){
                     resolve(data);
                }else{
                    reject()
                      Message.error(data.msg)
                }
               
            },
            error:function(){ 
                Message.error('登录失败')
                reject(new Error('登录失败'));
            }
        });
    }) 



    return ajax.post()
}
export function outLogin(){
    Cookies.remove('YFCOOKIE')
}



export function getUserInfo(){
    //Cookies.get('SLCOOKIE')
    return new Promise((resolve, reject)=>{
        $.ajax({
            url:  "/school/YfTokenServlet",
            data:{  actionServlet:'getLoginInfo',token:Cookies.get('YFCOOKIE')},    //参数值
            type:'post',   //请求方式
            success:function(data){
                resolve(data);
            },
            error:function(){ 
                reject(new Error('获得用户登录失败'));
            }
        });
    }) 



    // let data = ajax.post({action:'SLCOOKIE',yfCookie:Cookies.get('SLCOOKIE')})
    // if(data.code==1){
    //     return data.user
    // }else{
    //     return false
    // }
}


// WEBPACK FOOTER //
// ./src/api/base.js